// client/src/pages/Admin/ActivityLog/hooks/useActivityLog.ts

import { useState, useEffect, useCallback } from 'react';
import { ActivityLog, ActivityFilter } from '../types/activity.types';

export const useActivityLog = (initialFilter?: ActivityFilter) => {
    const [activities, setActivities] = useState<ActivityLog[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const [filter, setFilter] = useState<ActivityFilter>(initialFilter || {});
    const [total, setTotal] = useState(0);

    const fetchActivities = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const params = new URLSearchParams();
            if (filter.action) params.append('action', filter.action);
            if (filter.severity) params.append('severity', filter.severity);
            if (filter.startDate) params.append('startDate', filter.startDate.toISOString());
            if (filter.endDate) params.append('endDate', filter.endDate.toISOString());
            if (filter.search) params.append('search', filter.search);

            const response = await fetch(`/.netlify/functions/admin-activity-log?${params.toString()}`);
            const data = await response.json();

            if (data.success) {
                setActivities(data.data);
                setTotal(data.total || data.data.length);
            } else {
                setError(data.error || 'Failed to load activities');
            }
        } catch (err) {
            setError('Failed to load activities');
            console.error('Error fetching activities:', err);
        } finally {
            setLoading(false);
        }
    }, [filter]);

    useEffect(() => {
        fetchActivities();
    }, [fetchActivities]);

    return {
        activities,
        loading,
        error,
        total,
        filter,
        setFilter,
        refresh: fetchActivities,
    };
};
